var currentUrl= location.protocol+'//'+window.location.hostname+window.location.pathname+window.location.search;

function performContentSwitch(){
	let elements = document.querySelectorAll("[data-content-switch]");
	elements.forEach((item, index)=>{
		item.innerHTML = item.getAttribute("data-content-switch");
		item.removeAttribute("data-content-switch");
	});
}
function refreshGrid(cf,tf,page){

	 if( $('[data-content-switch]').length ) performContentSwitch();

	
	$('#categoryGrid').html('<div class="ajaxLoader on" style="height:300px; width:300px;"></div>');
	$.ajax({
		url : url,
		global : false,
		type : "POST",
		data: { 'cf':cf,'tf':tf,'page':page},
		dataType : "json",
		async : true,
		success : function(j) {
			switch (j.success) {
			case true:
				$('#categoryGrid').html(j.html);
				break;
			case false:

				break;
			}
		}
	});
	return false;
}

function pageGrid(p){
	return refreshGrid(cf,tf,p);
}


function sameHeight(minWidth, cssClass) {

	if ($(window).width() > minWidth) {

		var items = $(cssClass), // grab all the slides
		heights = [], // array to store heights
		tallest; // tallest slide

		if (items.length) {
			function normalizeHeights() {
				items.each(function() {
					heights.push($(this).outerHeight()); // add each slide's
					// height
				}); // to the array

				tallest = Math.max.apply(null, heights); // find the largest
				// height

				items.each(function() {
					$(this).css('min-height', tallest + 'px'); // set each
					// slide's
					// minimum
				}); // height to the largest
			}
			;

			normalizeHeights();
			$(window).on('resize orientationchange', function() {
				tallest = 0, heights.length = 0; // reset the variables

				items.each(function() {
					$(this).css('min-height', '0'); // reset each slide's height
				});

				normalizeHeights(); // run it again
			});
		}

	}

};


$(document).ready(function() {
	
	
	
	
	 // if ($(window).width() > 769) {
		    $('.navbar .dropdown').hover(function() {
		     // $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();

		    }, function() {
		     // $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();

		    });

		    $('.navbar .dropdown > a').click(function() {
		 
		    	if (typeof(this.href) != "undefined" && this.href ){
		             location.href = this.href;
		    	}
		    });

		//  }
	

	
	     
	// $("a.nav-link").on('hover', function(event) { 
	//	 if ($(this).hasClass( "dropdown-toggle" )){	 
	//	 }else{
	//		   var navMain = $(".navbar-collapse");
	//		    navMain.collapse('hide');
	//	 }
	//});
    
	 $(".toggle-content-btn").on('click', function(event) {
		 

	 	   var id = $(this).data('id');
	 	   
	 	   if ($(this).hasClass( "toggle-open" )){
	 		  $(this).removeClass( "toggle-open" );
	 		  $(this).addClass( "toggle-close" );
	 	
			  
			    $('#'+id).removeClass( "toggle-open" );
	            $('#'+id).addClass( "toggle-close" );
	 		  
	 		  
	 	   }else{
	 		  $(this).removeClass( "toggle-close" );
	 		  $(this).addClass( "toggle-open" ); 
	 		  
	 		 $('#'+id).removeClass( "toggle-close" );
	 		 $('#'+id).addClass( "toggle-open" ); 
	 		  
	 	   }
		  
	});
	 
    
	     
	     
    var topPadding =  $('.fixed-top').height();

    
    $(".fixed-box").each(function(i, elem) {
        if ($(window).width() > 991) {
    	   var $elem = $(elem);
    	   var elemHeight =  $elem.height();
    	   var elemWidth =  $elem.width();
    	    
    	   $elem.css('top', topPadding+2+'px');
    	   $elem.css('width',elemWidth+'px');
    	   $elem.css('height',elemHeight+'px');
        }
    });
    
    

    //$wrapper.addClass('dom-box-find');
    

    
    // console.log('conteinerHeight '+conteinerHeight);
    //console.log('MAX LINE '+maxLine);
     
    $(window).scroll(function() {

         if ($(window).width() > 991) {
    	
    	$(".fixed-box").each(function(i, elem) {
    		
    	var $elem = $(elem);
    	 var elemHeight =  $elem.height();
    	
        var $wrapper =   $elem.parents().filter('div.fixed-container-box');
       // $wrapper.addClass('dom-box-find');
        var conteinerHeight=$wrapper.height();
        var maxLine=$wrapper.height()-topPadding;
    	
        //console.log('MAX LINE '+maxLine);
        var offset     =       $elem.parents().filter('div.fixed-marker').offset();
 

        

    	
        var windowScrollTop = $(window).scrollTop();
  
            if ( offset.top -topPadding   < windowScrollTop) {
            	
            	$elem.addClass('fixed-active');
            	if (windowScrollTop >offset.top+ maxLine-elemHeight){
                    $elem.css('top', (offset.top+maxLine-windowScrollTop-elemHeight+topPadding)+'px');	
            	}else{
            	    $elem.css('top', topPadding+2+'px');
            		
            	}
            }else{
                $elem.removeClass('fixed-active');	
            }
       
            
    	   });   
    	
    }
            
            
    });
	
	
  


	$(".opis").each(function() {
		
		
		if ($(this).children('.text').length>0){
			
			var text = $(this).find('.text');

			
		$(this).append("<div class='wiecej'>Czytaj więcej...</div>");
		var wys = text.height();
		if ($(window).width() <= 640) {
			text.css('height', '0px');
		} else {
			text.css('height', '0px');
		}
		$(this).on('click', '.wiecej', function() {
			text.animate({
				height : wys
			}, 1000);
			$(this).attr('class', 'mniej');
			$(this).text("Zamknij");
		});
		$(this).on('click', '.mniej', function() {
			if ($(window).width() <= 640) {
				text.animate({
					height : '0px'
				}, 1000);
			} else {
				text.animate({
					height : '0px'
				}, 1000);
			}
			$(this).attr('class', 'wiecej');
			$(this).text("Czytaj więcej...");
		});
		
	}
		
	});



	$("a").on('click', function(event) {
		
		if (this.hash !== "") {
			var hash = this.hash;
			var elem = $("#" + hash.replace('#', '')).get(0);
			if (elem) {
				if ($(this).hasClass( "change-url" )){
					window.location = currentUrl+hash;
				}else{
					$('html, body').animate({
						scrollTop : (parseInt($(hash).offset().top)-parseInt(topPadding))
					}, 800, function() {
				
					});	
				}
			}
			 event.preventDefault();
			return false;
		}
	});
	
	

	$('.btn-contact-event').click(function() {
		$('#contactModal').modal('show');

	});


	$("a").each(function() {
		if (this.hash !== "" ) {
			var check=this.hash;
			if (check==$(this).attr('href')){
			if( $(this.hash).length==0 && $("[name='"+this.hash.replace("#", "")+"']").length==0 ){
				$(this).css("display", "none");
			}
			
		  }
		}
	});
	
	
	
	$(':not(.left-and-right-grid) + .left-and-right-grid, .left-and-right-grid:first').addClass('first-block');
	$('.left-and-right-grid:last').addClass('last-block');
	$('.left-and-right-grid + :not(.left-and-right-grid)').prev().addClass('last-block');

	$(':not(.left-and-right-grid2) + .left-and-right-grid2, .left-and-right-grid2:first').addClass('first-block');
	$('.left-and-right-grid2:last').addClass('last-block');
	$('.left-and-right-grid2 + :not(.left-and-right-grid2)').prev().addClass('last-block');





    if (typeof(cmi) !== 'undefined') {
        $('#offer_contact_conference').val(cmi);
    }
    if (typeof(categoryFromConferenceContact) !== 'undefined') {
        $('#offer_contact_categoryFrom').val(categoryFromConferenceContact);
    }
	
	$("#contact-confererence-form").validate({
		rules : {
			"offer_contact\[phone\]" : {
				required : false,
				minlength : 3,
				maxlength : 100,
			},
			"offer_contact\[email\]" : {
				required : true,
				minlength : 3,
				maxlength : 100,
			}
		},
		messages : {
			"offer_contact\[phone\]" : {
				minlength : "Min. 3 znaki",
				maxlength : "Max 100 znaków",
			},
			
			"offer_contact\[name\]" : {
				required : "Pole wymagane",
			},
			"offer_contact\[message\]" : {
				required : "Pole wymagane",
			},
			"offer_contact\[rulesAccepted\]" : {
				required : "Pole wymagane",
			},
			
			
			"offer_contact\[email\]" : {
				minlength : "Min. 3 znaki",
				maxlength : "Max 100 znaków",
				email : "Błędny adres email",
				required : "Pole wymagane",
			},
		},
		submitHandler : function(form) {
			$.ajax({
				url : $(form).attr('action'),
				global : false,
				type : "POST",
				data: $(form).serialize(),
				dataType : "json",
				async : true,
				success : function(j) {
					switch (j.success) {
					case true:
					    document.getElementById("contact-confererence-form").reset();
						$('#contact-confererence-forms-ajax-status').show();
						break;
					case false:

						break;
					}
				}
			});
		}
	});
	
	$('#contactModal').on('hidden.bs.modal', function (e) {
		$('#contact-confererence-forms-ajax-status').css("display", "none");
		})
	
	
	 sameHeight(786, '.first .term-box');
	
	
	$('#cookie-policy-accept').on('click', function(e)
			  {
			    e.preventDefault();
			    $.cookie('cookie_policy', 1, {path: '/', expires: 365});
			    $('#cookie-policy').hide('200');
			  });


});


$( window ).resize(function() {
	//fixedBasketSummary();
});
